import { List, Datagrid, TextField, EditButton } from "react-admin";

export const SpecialtyList = () => (
  <List>
    <Datagrid rowClick="edit">
      <TextField source="id" />
      <TextField source="code" />
      <TextField source="name" />
      <TextField source="comment" />
      <EditButton />
    </Datagrid>
  </List>
);
